import { userInfoQueryOptions } from '@/hooks/users/use-user-info';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function myIndexLoader() {
  return {
    promises: queryClient.ensureQueryData(userInfoQueryOptions).catch(catchFetcherError),
  };
}
